import React, { Component } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import NotificationDropdown from "./NotificationDropdown";
//i18n
import { withTranslation } from "react-i18next";

// users
import avatar2 from "../../../assets/images/users/avatar-2.jpg";

class ProfileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
    }));
  }

  render() {
    let username = "Admin";

    // Try to get user data from localStorage
    if (localStorage.getItem("user")) {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user.isSuperAdmin) {
          username = "Super Admin";
        } else if (user.firstName || user.lastName) {
          // Use team member's actual name
          username = `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.username || "Team Member";
        } else if (user.username) {
          username = user.username;
        }
      } catch (e) {
        console.error("Error parsing user data:", e);
      }
    } else if (localStorage.getItem("authUser")) {
      // Fallback to authUser if user not found
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const uNm = obj.email.split("@")[0];
        username = uNm.charAt(0).toUpperCase() + uNm.slice(1);
      } catch (e) {
        console.error("Error parsing authUser data:", e);
      }
    }

    return (
      <React.Fragment>
        <NotificationDropdown />
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block user-dropdown"
        >
          <DropdownToggle
            tag="button"
            className="btn header-item waves-effect"
            id="page-header-user-dropdown"
          >
            <img
              className="rounded-circle header-profile-user mr-1"
              src={avatar2}
              alt="Header Avatar"
            />
            <span className="d-none d-xl-inline-block ml-1 text-transform">
              {username}
            </span>
            <i className="mdi mdi-chevron-down d-none ml-1 d-xl-inline-block"></i>
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem tag={Link} to="/profile">
              <i className="ri-user-line align-middle mr-1"></i>{" "}
              {this.props.t("My Profile")}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem tag={Link} to="/logout" className="text-danger">
              <i className="ri-shut-down-line align-middle mr-1 text-danger"></i>{" "}
              {this.props.t("Logout")}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}

export default withTranslation()(ProfileMenu);
